"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zVenueCode = exports.VENUE_CODE_REQUIRED_CODE = exports.RESERVED_VENUE_CODES = exports.VENUE_CODE_PATTERN = void 0;
exports.normalizeVenueCode = normalizeVenueCode;
exports.isVenueCode = isVenueCode;
const zod_1 = require("zod");
/**
 * Venue codes (EclipseGG platform, 2026-10-19).
 *
 * One hosted server answers for every venue, and usernames are only unique
 * within a venue — every venue's owner starts as `owner`. So a staff sign-in
 * names its venue: the code typed once above the username and remembered by
 * the website and the apps after that. The code IS the existing `Venue.slug`;
 * there is no second column to keep in step.
 *
 * One rule, here, for every reader: the API's sign-in and its boot check of
 * LEGACY_DEFAULT_VENUE_SLUG, the staff website's remembered code, the
 * platform's create and edit forms, and the rename script.
 *
 * Lowercase only, and the reader lowercases for the person typing: a phone
 * keyboard capitalises the first letter by itself, and `Gamers-Escape` must
 * still be Gamers Escape. Stored lowercase, the lookup stays an exact match on
 * the slug's unique index.
 */
/** 3 to 32 characters: lowercase letters, digits and dashes, starting and ending with a letter or digit. */
exports.VENUE_CODE_PATTERN = /^[a-z0-9][a-z0-9-]{1,30}[a-z0-9]$/;
/**
 * Codes no venue may hold: the platform's own names — the admin host
 * (`admin`), the API (`api`), the kiosk portal (`portal`), the website (`www`)
 * and the platform itself — so no venue's code can be read as one of them.
 */
exports.RESERVED_VENUE_CODES = ['admin', 'api', 'portal', 'www', 'platform'];
/**
 * The 401 a staff sign-in gets when it names no venue and the server has no
 * LEGACY_DEFAULT_VENUE_SLUG to fall back on: the form asks for the code.
 */
exports.VENUE_CODE_REQUIRED_CODE = 'venue_code_required';
/** Trimmed and lowercased. Not validated: see {@link isVenueCode}. */
function normalizeVenueCode(raw) {
    return raw.trim().toLowerCase();
}
/**
 * True for an ALREADY-normalised value that matches the pattern and is not
 * reserved. Never normalises: `' Main'` is false here, `normalizeVenueCode`
 * first.
 */
function isVenueCode(value) {
    return (typeof value === 'string' &&
        exports.VENUE_CODE_PATTERN.test(value) &&
        !exports.RESERVED_VENUE_CODES.includes(value));
}
/**
 * A venue code as a form or a script submits it: trimmed, lowercased, then the
 * pattern, then the reserved list — in that order, so `' ADMIN '` is refused
 * as reserved, not as malformed.
 */
exports.zVenueCode = zod_1.z
    .string()
    .trim()
    .toLowerCase()
    .regex(exports.VENUE_CODE_PATTERN, 'Use 3 to 32 lowercase letters, digits or dashes, starting and ending with a letter or digit.')
    .refine((value) => !exports.RESERVED_VENUE_CODES.includes(value), 'That code is reserved.');
//# sourceMappingURL=venue-code.js.map